import React from 'react';
import {Link} from 'react-router-dom';
import {Field} from 'formik';
import {useTranslation} from 'react-i18next';
import TopCardElement from '../TopCardElement';
import CustomGreenCheckbox from '../../../Components/CustomCheckbox/CustomGreenCheckbox';
import {formatNumber} from '../../../assets/utils/utils';
import OrderSummary from './OrderSummary';
import infoIcon from '../../../assets/img/Cart/info 1.svg';
import s from '../Cart.module.css';
import formStyle from '../../../assets/common/CommonStyle.module.css';

interface BuyerInfoSectionProps {
	cartData: {
		name_client?: string;
		contract?: string;
		motivation_text?: string;
		balance_bonus?: number | string;
		pay_money?: number;
	} | null;
	activeMonth: number;
	values: {
		deferred: boolean;
		bonus: number | null;
	};
	maxBonus: number;
	setFieldValue: (field: string, value: any) => void;
	errors: any;
	touched: any;
}

const BuyerInfoSection: React.FC<BuyerInfoSectionProps> = ({
	cartData,
	activeMonth,
	values,
	maxBonus,
	setFieldValue,
	errors,
	touched,
}) => {
	const {t} = useTranslation();

	const handleBonusChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const value = event.currentTarget.value.replace(/[^0-9]/g, '');
		const numericValue = Number(value);

		if (numericValue <= maxBonus) {
			setFieldValue('bonus', numericValue);
		} else {
			setFieldValue('bonus', maxBonus);
		}
	};

	const finalAmount = (cartData?.pay_money ?? 0) - (values.bonus ?? 0);

	if (!cartData) return null;

	return (
		<div className={s.buyerContainer}>
			<TopCardElement title={t('Покупець')} number={'1'} />
			
			<div className={s.authInfo}>
				{t('Ви авторизовані як')} {cartData.name_client} (
				{t('номер лояльності')} {cartData.contract})
			</div>

			<div className={s.totalForMonth}>
				{t('За цей місяць у Вас вже зараховано')} {activeMonth} {t('Б')}
			</div>

			<div className={s.aboutYouActivity}>
				{t('про свою активність Ви можете переглянути на сторінці')}
				<Link to={'/my_accounts'}>{t('кабінету')}</Link>
			</div>

			<div className={s.blueButton}>{cartData.motivation_text}</div>

			<div className={s.ifYouWont}>
				{t(
					'Якщо Ви хочете надалі оформити ці бали на своїх партнерів, то поставте нижче позначку',
				)}
			</div>

			<div className={s.changeCheckboxWrapper}>
				<CustomGreenCheckbox
					setFieldValue={setFieldValue}
					required={false}
					labelTxt={t('зробити відкладеним оформленням')}
					id={'deferred'}
					name={'deferred'}
					checked={values.deferred}
				/>
				<img src={infoIcon} alt="info" />
			</div>

			<div className={s.totalForMonth}>
				{t('На вашому бонусному рахунку')}{' '}
				{formatNumber(cartData.balance_bonus?.toString() || '0')} SV
			</div>

			<div className={s.inputName}>{t('Застосувати знижку')}:</div>

			<div className={`${formStyle.fieldContainer} ${s.bonusInput}`}>
				<Field
					onChange={handleBonusChange}
					type="number"
					name="bonus"
					style={{width: '100%'}}
					max={maxBonus}
					value={values.bonus ?? ''}
				/>
			</div>

			{errors.bonus && touched.bonus && (
				<div className={s.errorMessage}>{errors.bonus}</div>
			)}

			<OrderSummary
				orderAmount={cartData?.pay_money ?? 0}
				bonusUsed={values.bonus}
				finalAmount={finalAmount}
			/>
		</div>
	);
};

export default BuyerInfoSection;

